import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useUser } from '../../hooks';
import logo from '../../public/img/logos/logo-carreras-light.png';

export default function Welcome() {
  const [user] = useUser();
  return (
    <div className="w-full flex flex-row flex-wrap h-full min-h-[700px] max-h-[730px] p-4 lg:p-12">
      <div className="w-full lg:w-1/2 lg:pl-8">
        <div className="w-full max-w-[453px]">
          <Image src={logo} alt="Carreras logo" className="w-[280px]" />
          <div className="mt-16">
            <h1 className="text-2xl lg:text-5xl text-neutral-600 font-bold">
              <span className="text-cyan">Carreras</span>
              <br /> Scholarship <span className="text-green">Application</span>
            </h1>
            {/* <p className="text-lg text-neutral-600 font-light mt-2">
              This scholarship is available to students pursuing studies at
              numerous tertiary-level institutions across Jamaica and are in
              need of financial assistance. They must be Jamaican citizens who
              are 18 years and older and have an exemplary academic record.
            </p> */}
          </div>
          <div className="mt-8 w-full flex flex-col">
            <Link
              href="/request-scholarship/[...id]"
              as="/request-scholarship/1"
              className="font-bold text-lg w-full py-3 bg-dark-blue text-white text-center rounded-xl"
            >
              Request scholarship
            </Link>
            {user ? (
              <Link
                href="/profile"
                className="mt-3 font-bold text-lg w-full py-3 bg-green text-white text-center rounded-xl"
              >
                View profile
              </Link>
            ) : null}
          </div>
        </div>
      </div>
      <div className="w-full lg:w-1/2 hidden lg:block relative">
        <div className="w-full h-full rounded-2xl rounded-bl-[300px] top-0 left-0 absolute z-30 bg-dark-blue opacity-0" />
        <div
          className="w-full h-full rounded-2xl rounded-bl-[300px] top-0 left-0 absolute z-20 bg-right bg-no-repeat bg-cover --saturate-0"
          style={{
            backgroundImage: `url('/img/bg/bg-1.jpg')`,
          }}
        />
        <div className="bg-cyan w-full h-full top-[30px] right-[30px] rounded-2xl rounded-bl-[300px] max-h-[700px] absolute z-10" />
      </div>
    </div>
  );
}
